import { render } from "./HelloWangHo.vue?vue&type=template&id=e420ba22&scoped=true"
import script from "./HelloWangHo.vue?vue&type=script&lang=js"
export * from "./HelloWangHo.vue?vue&type=script&lang=js"

import "./HelloWangHo.vue?vue&type=style&index=0&id=e420ba22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e420ba22"]])

export default __exports__